// NOTE: the HTML Entities library is loaded from a standalone script
// import * as he from "he";

// NOTE: the glue code will do all imports / exports on the globalThis object
// TODO: stub the UMD __importStar function in a later commit to make this
//       unnecessary
// @ts-ignore
var he = self._workaround_umd_exports.he;

import {
    // NOTE: available in/on the global namespace, not part of this bundle
    activateTooltips,
} from "../../common";

import {
    EditionsViewer,
} from '../../lib-custom';

import {
    // plugins.reader-pagination
    ReaderPagination,

    // plugins.reader
    BookPage,
    ReaderPanelEnum,
} from "../../plugins";

import { IReaderDefaults, ReaderLayout } from "./readerLayout";

class BookHeader extends ReaderPagination {
    // private parentReader: ReaderLayout; // moved to the base/parent class
    private bookId: string;
    private versionId: string;
    private sc: ServerCommunication;
    private bookTitle: string;
    private audioOnly: boolean = true;
    private toolButtons: JQuery<HTMLButtonElement> = $();

    viewer: EditionsViewer;

    constructor(parentReader: ReaderLayout, sc: ServerCommunication, headerDiv: HTMLDivElement, bookTitle: string) {
        super(headerDiv);
        this.parentReader = parentReader;
        this.readerLayout = parentReader;
        this.sc = sc;
        this.bookId = parentReader.getBookId();
        this.versionId = parentReader.getVersionId();
        this.bookTitle = bookTitle;
        this.init(
            (pageId, pageIndex, scrollTo, pageXmlId) => // pageChangedCallback
        {
            this.parentReader.notifyPanelsMovePage(pageIndex, scrollTo);
            this.readerLayout.currentPageIndex = pageIndex;
            this.updateSlider(pageIndex);
            this.readerLayout.pageChangedCallback(pageId, pageXmlId);
        });

        this.viewer = new EditionsViewer();

        this.viewer.setup({
            // TODO: make this actually configurable
            chars_in_page: 1800,
        });
    }

    private updateSlider(pageIndex: number)
    {
        var slider = $(this.readerContainer).find(".slider");
        $(slider).slider().slider("value", pageIndex);
        $(slider).find(".ui-slider-handle").find(".tooltip-inner")
            .html(`${localization.translate("page", "BookReader").value}: ${this.pages[pageIndex].text}`);
    }


    public getInnerHtml(deviceType: Device): HTMLDivElement {
        var innerHtml: HTMLDivElement = null;
        if (deviceType === Device.Mobile) {
            innerHtml = this.createMobileHeaderDiv(this.bookTitle);
        }
        if (deviceType === Device.Desktop) {
            innerHtml = this.createDesktopHeaderDiv(this.bookTitle);
        }
        return innerHtml;
    }

    private getEditionNote(addHeader: boolean): HTMLDivElement {
        var editionNoteDiv = document.createElement("div");
        var loader = lv.create(null, "edition-note-loading lv-circles lv-mid sm");
        $(editionNoteDiv).addClass("edition-note-wrapper");
        if (addHeader) {
            var editionNoteHeader = document.createElement("h3");
            $(editionNoteHeader).append(localization.translate("editionNote", "BookReader").value);
            $(editionNoteDiv).append(editionNoteHeader);
        }
        $(editionNoteDiv).append(loader.getElement());

        var editionNote: JQueryXHR = this.sc.getEditionNote(this.bookId);
        editionNote.done((response: { editionNote: string }) => {
            var editionNoteText = document.createElement("div");
            const textWrapper = document.createElement('div');

            $(editionNoteText).addClass("edition-note-text");
            textWrapper.className = 'text-content';

            let content = null;

            if (response.editionNote === "") {
                content = localization.translate(
                    'noEditionNote', 'BookReader').value;

            } else {
                content = response.editionNote;
            }

            $(textWrapper).append(content);
            this._renderFootnotes(textWrapper);

            // TODO: make them wider for long footnotes… (e.g. BiblDrážď_J)
            activateTooltips(null, textWrapper);

            editionNoteText.appendChild(textWrapper);
            editionNoteDiv.appendChild(editionNoteText);
        });
        editionNote.fail(() => {
            $(editionNoteDiv).append(localization.translate("failedToLoadNote", "BookReader").value);
        });
        editionNote.always(() => {
            $(editionNoteDiv).find(".edition-note-loading").remove();
        });

        return editionNoteDiv;
    }

    private _renderFootnotes(pageContainer: HTMLDivElement): void
    {
        this.viewer.root = pageContainer;

        this.viewer.createFootnotesInWholeDocument();
    }

    private getBookDetail(): HTMLDivElement {
        //  OLD: since TableBuilder is used here directly even though
        //       interpretTable could have been employed and since this code
        //       is well isolated, let’s rebuild

        var bookDetailDiv = document.createElement("div");
        $(bookDetailDiv).addClass("book-detail-wrapper");
        var bookDetailHeader = document.createElement("h3");
        $(bookDetailHeader).append(localization.translate("information", "BookReader").value);
        bookDetailDiv.appendChild(bookDetailHeader);

        // TODO: only get this once, for ****’s sake
        var bookDetail: JQueryXHR = this.sc.getBookDetail(this.bookId);
        bookDetail.done((response) => {
            // var detailData = response["detail"];
            const detailData = response;

            const renderer: BottomPanelConfiguration = this.getInfoRenderer();

            if (!renderer) {
                console.warn('bibliographyFactory is not (yet?) available');
                return;
            }

            /*
            var detailTable = new TableBuilder();
            var editors: string = "";
            for (var i = 0; i < detailData.Editors.length; i++) {
                var editor = detailData.Editors[i];
                editors += editor.FirstName + " " + editor.LastName;
                if (i + 1 !== detailData.Editors.length) {
                    editors += ", ";
                }
            }

            // DONE: deduplicate
            // TODO: or reimplement with/in React
            detailTable.makeTableRow(localization.translate("editor", "BookReader").value, editors);
            // DONE: only if not null (removed below)
            //  OLD: why was this not migrated to the VariableInterpreter framework?
            detailTable.makeTableRow(localization.translate("original", "BookReader").value, detailData.LiteraryOriginal);
            detailTable.makeTableRow(localization.translate("relicAbbr", "BookReader").value, detailData.RelicAbbreviation);
            detailTable.makeTableRow(localization.translate("sourceAbbr", "BookReader").value, detailData.SourceAbbreviation);
            detailTable.makeTableRow(localization.translate("sourcePartAbbr", "BookReader").value, detailData.SourcePartAbbreviation);
            detailTable.makeTableRow(localization.translate("literaryType", "BookReader").value, detailData.LiteraryKinds);
            detailTable.makeTableRow(localization.translate("literaryGenre", "BookReader").value, detailData.LiteraryGenre);
            detailTable.makeTableRow(localization.translate("EditionLastModification", "BookReader").value, detailData.CreateTimeString);

            $(detailTable.build()).find(".bib-table-cell").each((index, element) => {
                if (element.innerHTML === "" || element.innerHTML === "undefined") {
                    const row = element.parentElement;
                    row.remove();

                    return;
                    element.innerHTML = `&lt;${localization.translate("nullValue", "BookReader").value}&gt;`;
                }
            });

            $(bookDetailDiv).append(detailTable.build());
            */

            const renderedDiv = document.createElement('div');
            // Bootstrap: top+bottom (vertical) margins of a third size
            // renderedDiv.className = 'my-3';
            bookDetailDiv.appendChild(renderedDiv);

            // NOTE: this calls renderBibliographyLine (as well as TableBuilder)
            renderedDiv.innerHTML = renderer.getBody(detailData);
            renderer.replacePlaceholders(renderedDiv);

        });
        bookDetail.fail(() => {
            $(bookDetailDiv).append(localization.translate("FailedToLoadInfo", "BookReader").value);
        });

        return bookDetailDiv;
    }

    private getInfoRenderer(): BottomPanelConfiguration
    {
        /*
        //  OLD: this wraps the VariableInterpreter
        const params = '{$elements}, {$data}, {$constants}';
        const renderer = new MiddlePanelConfiguration({
            body: '{$citation}',
            variables: {
                '$citation': {
                    type: 'script',
                    pattern: `renderBibliographyLine(${params})`,
                },
            },
        });

        return renderer;
        */

        const bibliographyFactory = bibliographyModule.getBibliographyFactory(null);

        if (!bibliographyFactory) {
            return null;
        }

        return bibliographyFactory.configuration.getBottomPanelConfig();
    }

    private getAuthors(target: JQuery) {
        var authors: string = "";
        // TODO: only get this once, for ****’s sake
        var bookDetail: JQueryXHR = this.sc.getBookDetail(this.bookId);
        bookDetail.done((response) => {
            // var detailData = response["detail"];
            // TODO: client-side type?
            const detailData = response;

            if (detailData.Authors.length !== 0) {

                for (var i = 0; i < detailData.Authors.length; i++) {
                    var author = detailData.Authors[i];

                    // NOTE: the trimming is necessary for editions that don’t
                    //       provide author names in the Last, First format but
                    //       rather just First Last
                    authors += (author.FirstName + " " + author.LastName + (
                        author.Suffix ?? '')).trim();

                    if (i + 1 !== detailData.Authors.length) {
                        authors += ", ";
                    }
                }
                authors += ": ";
                target.prepend(authors);
            }
        });
        bookDetail.fail(() => {
            target.prepend(`&lt;${localization.translate("failedToLoadAuthors", "BookReader").value}&gt;`);
        });
    }

    private makeToolButtons(deviceType: Device, disabledButtons: boolean = false): HTMLDivElement {

        var toolButtonsDiv = document.createElement("div");
        $(toolButtonsDiv).addClass("tool-panel buttons");
        var buttonsContainer = document.createElement("div");
        $(buttonsContainer).addClass("buttons-container");
        var button = new ButtonFactory(this.parentReader, deviceType);

        var addBookmarksButton = button.createAddBookmarkButton("bookmark",
            localization.translate("addBoookmark", "BookReader").value,
            this.parentReader.bookmarksPanelId
        );
        buttonsContainer.appendChild(addBookmarksButton);
        this.toolButtons = this.toolButtons.add(addBookmarksButton);

        var bookmarksButton =
            button.createToolButton("bookmark",
                localization.translate(this.parentReader.bookmarksPanelId, "BookReader").value,
                this.parentReader.bookmarksPanelId);
        buttonsContainer.appendChild(bookmarksButton);
        this.toolButtons = this.toolButtons.add(bookmarksButton);

        var contentButton = button.createToolButton("book",
            localization.translate(this.parentReader.contentPanelId, "BookReader").value,
            this.parentReader.contentPanelId);
        buttonsContainer.appendChild(contentButton);
        this.toolButtons = this.toolButtons.add(contentButton);

        var searchResultButton = button.createToolButton("search",
            localization.translate(this.parentReader.searchPanelId, "BookReader").value,
            this.parentReader.searchPanelId);
        buttonsContainer.appendChild(searchResultButton);
        this.toolButtons = this.toolButtons.add(searchResultButton);

        if (this.parentReader.showPanelList.indexOf(ReaderPanelEnum.TermsPanel) >= 0) {
            var termsButton = button.createToolButton("list-alt",
                localization.translate(this.parentReader.termsPanelId, "BookReader").value,
                this.parentReader.termsPanelId);
            buttonsContainer.appendChild(termsButton);
            this.toolButtons = this.toolButtons.add(termsButton);
        }

        toolButtonsDiv.appendChild(buttonsContainer);

        if (deviceType === Device.Mobile) {
            $(toolButtonsDiv).addClass("buttons");
            var showPanelButton = button.createButton("display-panel", "wrench");
            $(showPanelButton).click(() => {
                if ($(showPanelButton.firstChild as Element).hasClass("glyphicon-chevron-left")) {
                    $(showPanelButton.firstChild as Element)
                        .removeClass("glyphicon-chevron-left")
                        .addClass("glyphicon-wrench");
                    $(toolButtonsDiv).animate({
                        "left": "-116.5"
                    } as JQuery.PlainObject);
                } else if ($(showPanelButton.firstChild as Element).hasClass("glyphicon-wrench")) {
                    $(showPanelButton.firstChild as Element)
                        .removeClass("glyphicon-wrench")
                        .addClass("glyphicon-chevron-left");
                    $(toolButtonsDiv).animate({
                        "left": "0"
                    } as JQuery.PlainObject);
                }
            });

            toolButtonsDiv.appendChild(showPanelButton);
        }



        return toolButtonsDiv;

    }

    private makeViewButtons(deviceType: Device): HTMLDivElement {
        var viewControl: HTMLDivElement = document.createElement("div");
        $(viewControl).addClass("view-control");
        viewControl.id = "view";
        var buttonObject = new ButtonFactory(this.parentReader, deviceType);
        var viewButtons = document.createElement("div");
        $(viewButtons).addClass("buttons");
        var hasBookText: boolean = false;
        var hasBookImage: boolean = false;
        var hasBookPage: JQueryXHR = this.sc.hasBookPage(this.bookId, this.versionId);
        hasBookPage.done((response: { hasBookPage: boolean }) => {
            if (response.hasBookPage) {
                var textButton = buttonObject.createViewButton("font", // iconName: not literally "font" (not its size); this button simply reopens a closed text view
                    localization.translate("reopenText", "BookReader").value,  // XXX: this.parentReader.textPanelId (== "text" ~> "Text") is not a sufficient label
                    localization.translate(this.parentReader.textPanelId, "BookReader").value, // XXX: but it must be used in the panel title
                    localization.translate("reopenText", "BookReader").value, // tooltip
                    this.parentReader.textPanelId);
                hasBookText = true;
                if (!$(".lm_popin").is("div")) {
                    textButton.click();
                }
                $(".page-navigation-container-helper").removeClass("hidden");
                viewButtons.appendChild(textButton);

                var checkboxDiv = this.createCheckboxDiv();
                viewControl.appendChild(checkboxDiv);
                this.audioOnly = false;
            }
        });
        var hasBookImageAjax: JQueryXHR;
        $.when(hasBookPage).then(() => {
            hasBookImageAjax = this.sc.hasBookImage(this.bookId, this.versionId);

            hasBookImageAjax.done((response: { hasBookImage: boolean }) => {
                // TODO: drop this hack
                if (this.readerLayout.bookType == 'Grammar') {
                    response.hasBookImage = true;
                }

                if (response.hasBookImage) {
                    var imageButton = buttonObject.createViewButton("picture",
                        localization.translate(this.parentReader.imagePanelId, "BookReader").value,
                        null, // panel title
                        null, // tooltip
                        this.parentReader.imagePanelId);
                    hasBookImage = true;
                    if (!hasBookText && !$(".lm_popin").is("div")) {
                        imageButton.click();
                        $(".page-navigation-container-helper").removeClass("hidden");
                    }
                    viewButtons.appendChild(imageButton);
                    this.audioOnly = false;
                }
            });
        });

        $.when(hasBookPage, hasBookImageAjax).then(() => {
            var audioBook: JQueryXHR = this.sc.getAudioBook(this.bookId);
            audioBook.done((response: { audioBook: IAudioBookSearchResultContract }) => {
                if (response.audioBook.Tracks.length > 0) {
                    var audioButton = buttonObject.createViewButton("music",
                        localization.translate(this.parentReader.audioPanelId, "BookReader").value,
                        null, // panel title
                        null, // tooltip
                        this.parentReader.audioPanelId);

                    if (!hasBookText && !hasBookImage && !$(".lm_popin").is("div")) {
                        audioButton.click();
                        $(".page-navigation-container-helper").removeClass("hidden");
                    }
                    viewButtons.appendChild(audioButton);

                    if (this.audioOnly) {
                        this.toolButtons.each((index, element: HTMLButtonElement) => {
                            (element as HTMLButtonElement).disabled = true;
                        });
                    }
                }
            });
        });

        if (deviceType === Device.Mobile) {
            var editionNoteButton = buttonObject.createButton("display-note", "comment");
            $(editionNoteButton)
                .attr("data-toggle", "modal")
                .attr("data-target", "#book-info-modal")
                .click(() => {
                    $("#modalHeader")
                        .empty()
                        .append(localization.translate("editionNote", "BookReader").value);

                    $("#modalBody")
                        .empty()
                        .append(this.getEditionNote(false));
                });
            var editionNoteLabel = document.createElement("span");
            $(editionNoteLabel).addClass("button-text");
            $(editionNoteLabel).append(localization.translate("editionNote", "BookReader").value);
            $(editionNoteButton).append(editionNoteLabel);
            viewButtons.appendChild(editionNoteButton);
        }


        viewControl.appendChild(viewButtons);
        return viewControl;
    }

    private createCheckboxDiv(): HTMLDivElement {
        //  XXX: this is just (a) portal type configuration
        var readerOptions = JSON.parse(he.decode($("#readerOptions").data("options"))) as IReaderOptions;
        const defaults: IReaderDefaults = this.parentReader.defaults;

        var checkboxesDiv = window.document.createElement("div");
        $(checkboxesDiv).addClass("reader-settings-checkboxes-area");

        var showPageCheckboxDiv: HTMLDivElement = window.document.createElement("div");
        var showPageNameCheckbox: HTMLInputElement = window.document.createElement("input");
        showPageNameCheckbox.type = "checkbox";
        showPageNameCheckbox.checked = defaults.showPageNames;

        $(showPageNameCheckbox).change((eventData) => {
            var readerText: JQuery = $("#" + this.parentReader.textPanelId).find(".reader-text");
            var currentTarget: HTMLInputElement = <HTMLInputElement>(eventData.currentTarget as Node);
            this.parentReader.readerLayout.eventHub.emit("toggleComments", currentTarget.checked, "reader-text-show-page-names");
            this.parentReader.notifyPanelsMovePage(this.currentPageIndex, true);
        });

        var pageNameSlider = document.createElement("label");
        $(pageNameSlider).addClass("switch");

        var showPageNameLabel: HTMLLabelElement = window.document.createElement("label");
        showPageNameLabel.innerHTML = localization.translate("pageNames", "BookReader").value;
        showPageCheckboxDiv.appendChild(showPageNameCheckbox);
        showPageCheckboxDiv.appendChild(pageNameSlider);
        showPageCheckboxDiv.appendChild(showPageNameLabel);
        showPageNameCheckbox.id = "checkbox-show-page-numbers";
        showPageNameLabel.setAttribute("for", showPageNameCheckbox.id);
        pageNameSlider.setAttribute("for", showPageNameCheckbox.id);
        checkboxesDiv.appendChild(showPageCheckboxDiv);

        if (false) { // XXX: "separate pages" functionality is not desired by editors as separating between folios makes little sense
            var separatePagesDiv: HTMLDivElement = window.document.createElement("div");
            var separatePagesCheckbox: HTMLInputElement = window.document.createElement("input");
            separatePagesCheckbox.type = "checkbox";

            $(separatePagesCheckbox).change((eventData) => {
                var readerText = $("#" + this.parentReader.textPanelId).find(".reader-text");
                var currentTarget: HTMLInputElement = <HTMLInputElement>(eventData.currentTarget as Node);
                this.parentReader.readerLayout.eventHub.emit("toggleComments", currentTarget.checked, "reader-text-pages-separated");
                this.parentReader.notifyPanelsMovePage(this.currentPageIndex, true);
            });

            var pageOnNewLineSlider = document.createElement("label");
            $(pageOnNewLineSlider).addClass("switch");

            var separatePagesLabel: HTMLLabelElement = window.document.createElement("label");
            separatePagesLabel.innerHTML = localization.translate("separatePages", "BookReader").value;
            separatePagesDiv.appendChild(separatePagesCheckbox);
            separatePagesDiv.appendChild(pageOnNewLineSlider);
            separatePagesDiv.appendChild(separatePagesLabel);
            separatePagesCheckbox.id = "checkbox-page-separation";
            separatePagesLabel.setAttribute("for", separatePagesCheckbox.id);
            pageOnNewLineSlider.setAttribute("for", separatePagesCheckbox.id);
            checkboxesDiv.appendChild(separatePagesDiv);
        }

        if (readerOptions.displayNotes) {
            var showCommentCheckboxDiv: HTMLDivElement = window.document.createElement("div");
            var showCommentCheckbox: HTMLInputElement = window.document.createElement("input");
            showCommentCheckbox.type = "checkbox";
            showCommentCheckbox.checked = defaults.showApparatus;

            $(showCommentCheckbox).change((eventData) => {
                var readerText = $("#" + this.parentReader.textPanelId).find(".reader-text");
                var currentTarget: HTMLInputElement = <HTMLInputElement>(eventData.currentTarget as Node);
                this.parentReader.readerLayout.eventHub.emit("toggleComments", currentTarget.checked, "show-notes");
                this.parentReader.notifyPanelsMovePage(this.currentPageIndex, true);
            });

            var commentSlider = document.createElement("label");
            $(commentSlider).addClass("switch");

            var showCommentLabel: HTMLLabelElement = window.document.createElement("label");
            showCommentLabel.innerHTML = localization.translate("notes", "BookReader").value;
            showCommentCheckboxDiv.appendChild(showCommentCheckbox);
            showCommentCheckboxDiv.appendChild(commentSlider);
            showCommentCheckboxDiv.appendChild(showCommentLabel);
            showCommentCheckbox.id = "checkbox-show-comment";
            showCommentLabel.setAttribute("for", showCommentCheckbox.id);
            commentSlider.setAttribute("for", showCommentCheckbox.id);
            checkboxesDiv.appendChild(showCommentCheckboxDiv);
        }
        return checkboxesDiv;
    }

    private createDesktopHeaderDiv(bookTitle: string): HTMLDivElement {
        var headerDiv = document.createElement("div");
        headerDiv.appendChild(this.informationDiv(bookTitle, Device.Desktop));

        var controlsDiv = document.createElement("div");
        $(controlsDiv).addClass("reader-controls content-container");

        var buttonsDiv = document.createElement("div");
        $(buttonsDiv).addClass("buttons-container");

        controlsDiv.appendChild(this.makeSlider());
        buttonsDiv.appendChild(this.makeToolButtons(Device.Desktop));
        buttonsDiv.appendChild(this.createPagination(
            true, // multiStepArrow
            pageIndex => // clickedPaginationLinkCallback
            {
                this.parentReader.readerLayout.eventHub.emit(
                    'moveToPageNumber', pageIndex);
            },
            (pageId, pageXmlId) => // clickedPageNumberCallback
            {
                this.parentReader.readerLayout.eventHub.emit(
                    'navigationClicked', pageId, pageXmlId);
            },
        ));
        buttonsDiv.appendChild(this.makeViewButtons(Device.Desktop));

        controlsDiv.appendChild(buttonsDiv);
        headerDiv.appendChild(controlsDiv);

        return headerDiv;
    }

    // TODO: deduplicate, ffs
    private createMobileHeaderDiv(bookTitle: string): HTMLDivElement {
        var headerDiv = document.createElement("div");
        headerDiv.appendChild(this.informationDiv(bookTitle, Device.Mobile));

        var controlsDiv = document.createElement("div");
        $(controlsDiv).addClass("reader-controls content-container");
        controlsDiv.appendChild(this.makeViewButtons(Device.Mobile));
        controlsDiv.appendChild(this.createPagination(
            true, // multiStepArrow
            pageIndex => // clickedPaginationLinkCallback
            {
                this.parentReader.readerLayout.eventHub.emit(
                    'moveToPageNumber', pageIndex);
            },
            (pageId, pageXmlId) => // clickedPageNumberCallback
            {
                this.parentReader.readerLayout.eventHub.emit(
                    'navigationClicked', pageId, pageXmlId);
            },
        ));
        controlsDiv.appendChild(this.makePageInput());
        controlsDiv.appendChild(this.makeToolButtons(Device.Mobile));
        headerDiv.appendChild(controlsDiv);

        return headerDiv;
    }

    private makePageInput(): HTMLDivElement {
        var pageInputDiv: HTMLDivElement = document.createElement("div");
        pageInputDiv.classList.add("page-input");

        var pageInputText = document.createElement("input");
        pageInputText.setAttribute("type", "text");
        pageInputText.setAttribute("id", "pageInputText");
        pageInputText.setAttribute("placeholder", localization.translate("GoToPage", "BookReader").value);
        pageInputText.classList.add("page-input-text");
        pageInputDiv.appendChild(pageInputText);

        var pageInputButton = document.createElement("button");
        $(pageInputButton).addClass("btn btn-default page-input-button");

        var pageInputButtonSpan = document.createElement("span");
        $(pageInputButtonSpan).addClass("glyphicon glyphicon-arrow-right");
        $(pageInputButton).append(pageInputButtonSpan);

        $(pageInputButton).click(() => {
            var pageName = $("#pageInputText").val();
            var pageIndex: number = -1;
            for (var i = 0; i < this.pages.length; i++) {
                if (this.pages[i].text === pageName) {
                    pageIndex = i;
                    break;
                }
            }

            if (this.pages[pageIndex] !== undefined) {
                var page: BookPage = this.pages[pageIndex];
                this.parentReader.readerLayout.eventHub.emit("navigationClicked", page.pageId);
            } else {
                console.error("missing page " + pageIndex);
            }
        });

        pageInputDiv.appendChild(pageInputButton);

        $(pageInputText).keypress((event: any) => {
            var keyCode = event.which || event.keyCode;
            if (keyCode === 13) {     //13 = Enter
                $(pageInputButton).click();
                event.preventDefault();
                event.stopPropagation();
                return false;
            }
// ReSharper disable once NotAllPathsReturnValue
        });

        this.parentReader.activateTypeahead(pageInputText);

        return pageInputDiv;
    }


    private makeSlider(): HTMLDivElement {
        var slider: HTMLDivElement = document.createElement("div");
        $(slider).addClass("slider");
        $(slider).slider({
            min: 0,
            max: this.pages.length - 1,
            value: 0,
            start: (event) => {
                $(event.target as Node as HTMLElement).find(".ui-slider-handle").find(".slider-tip").show();
            },
            stop: (event) => {
                $(event.target as Node as HTMLElement).find(".ui-slider-handle").find(".slider-tip").fadeOut(1000);
            },
            slide: (event, ui) => {
                $(event.target as Node as HTMLElement).find(".ui-slider-handle").find(".slider-tip").stop(true, true);
                $(event.target as Node as HTMLElement).find(".ui-slider-handle").find(".slider-tip").show();
                if (this.pages[ui.value] !== undefined) {
                    $(event.target as Node as HTMLElement).find(".ui-slider-handle").find(".tooltip-inner").html("Strana: " + this.pages[ui.value].text);
                } else {
                    console.error("missing page " + ui.value);
                }
            },
            change: (event: Event, ui: JQueryUI.SliderUIParams) => {
                if (this.parentReader.currentPageIndex !== ui.value) {
                    this.parentReader.readerLayout.eventHub.emit("moveToPageNumber", <any>ui.value);
                }
            }
        });

        var sliderTooltip: HTMLDivElement = document.createElement("div");
        sliderTooltip.classList.add("tooltip", "top", "slider-tip");
        var arrowTooltip: HTMLDivElement = document.createElement("div");
        arrowTooltip.classList.add("tooltip-arrow");
        sliderTooltip.appendChild(arrowTooltip);

        var innerTooltip: HTMLDivElement = document.createElement("div");
        $(innerTooltip).addClass("tooltip-inner");
        if (this.pages[0] !== undefined) {
            $(innerTooltip).html(`${localization.translate("page", "BookReader").value}: ${this.pages[0].text}`);
        } else {
            console.error("missing page " + 0);
        }
        sliderTooltip.appendChild(innerTooltip);
        $(sliderTooltip).hide();

        var sliderHandle: JQuery = $(slider).find(".ui-slider-handle");
        sliderHandle.append(sliderTooltip);
        sliderHandle.hover((event) => {
            $(event.target).find(".slider-tip").stop(true, true);
            $(event.target).find(".slider-tip").show();
        });
        sliderHandle.mouseout((event) => {
            $(event.target).find(".slider-tip").fadeOut(1000);
        });
        return slider;
    }

    private informationDiv(bookTitle: string, deviceType: Device): HTMLDivElement {
        var buttonObject = new ButtonFactory(this.parentReader, deviceType);
        var bookInfoDiv: HTMLDivElement = document.createElement("div");
        $(bookInfoDiv).addClass("book-details");

        var editionNoteDiv = this.getEditionNote(true);

        var title = document.createElement("span");
        $(title).addClass("title");

        const bookHeaderButtonsWrapper = document.createElement('div');
        $(bookHeaderButtonsWrapper).addClass('reader-controls');

        var bookHeaderButtons = document.createElement("div");
        $(bookHeaderButtons).addClass('buttons-container buttons');

        bookInfoDiv.appendChild(title);
        if (deviceType === Device.Desktop) {
            $(title).text(bookTitle);
            this.getAuthors($(title));

            const detailsButton = buttonObject.createToolButton(
                'info-sign', // iconName
                // 'Informace o edici („detaily“?)', // label
                localization.translate('information', 'BookReader').value,
                'more', // buttonId
                false // hasToolPanel
            );

            $(detailsButton).on('click', (event) =>
            {
                const button = event.delegateTarget;
                const iconSpan = button.querySelector('span.glyphicon');

                var target: JQuery = $(event.target as Node as HTMLInputElement);

                var title = target.parents(".book-details").find(".title");
                title.toggleClass("full"); // XXX: full = details-show + commentary-shown?

                var details = target.parents(".book-details").find(".collapsible-details");
                if (!details.is(":visible")) {
                    $(iconSpan).removeClass("glyphicon-info-sign");
                    $(iconSpan).addClass("glyphicon-chevron-up");
                    details.collapse("show");
                } else {
                    $(iconSpan).removeClass("glyphicon-chevron-up");
                    $(iconSpan).addClass("glyphicon-info-sign");
                    details.collapse("hide");
                }
            });

            bookHeaderButtons.appendChild(detailsButton);

            // modeled after a Device.Mobile block in makeViewButtons and (as a next step) the code just above
            const editionNoteButton = buttonObject.createToolButton(
                'comment', // iconName
                // 'Ediční poznámka', // label
                localization.translate('editionNote', 'BookReader').value,
                'display-note', // buttonId
                false // hasToolPanel
            );

            $(editionNoteButton).on('click', (event) =>
            {
                const button = event.delegateTarget;
                const iconSpan = button.querySelector('span.glyphicon');

                    var target: JQuery = $(event.target as Node as HTMLInputElement);

                    // var title = target.parents(".book-details").find(".title");
                    // title.toggleClass("full"); // XXX: full = details-show + commentary-shown?

                var details = target.parents(".book-details").find(".collapsible-commentary");
                if (!details.is(":visible")) {
                    $(iconSpan).removeClass("glyphicon-info-sign");
                    $(iconSpan).addClass("glyphicon-chevron-up");
                    details.collapse("show");
                } else {
                    $(iconSpan).removeClass("glyphicon-chevron-up");
                    $(iconSpan).addClass("glyphicon-info-sign");
                    details.collapse("hide");
                }
            });

            /*
            var editionNoteLabel = document.createElement("span");
            $(editionNoteLabel).addClass("button-text");
            $(editionNoteLabel).append(localization.translate("editionNote", "BookReader").value);
            $(editionNoteButton).append(editionNoteLabel);
            */

            bookHeaderButtons.appendChild(editionNoteButton);
        }

        if (deviceType === Device.Mobile) {
            var bookDetailDiv = this.getBookDetail();
            var bookDetailButton = buttonObject.createButton("display-details", "info-sign");
            $(bookDetailButton)
                .attr("data-toggle", "modal")
                .attr("data-target", "#book-info-modal")
                .click(() => {
                    $("#modalHeader")
                        .empty()
                        .append(bookTitle);
                    this.getAuthors($("#modalHeader"));

                    $("#modalBody")
                        .empty()
                        .append(bookDetailDiv);
                });
            title.appendChild(bookDetailButton);
            $(title).append(bookTitle);


        }

        var fullscreenButton = buttonObject.createButton("fullscreen", "fullscreen");
        $(fullscreenButton).click(() => {
            var $fullscreenButtonFirstChild = $(fullscreenButton.firstChild as Node as HTMLElement);
            if ($fullscreenButtonFirstChild.hasClass("glyphicon-fullscreen")) {
                $("#ReaderDiv").addClass("fullscreen");
                $("body").addClass("fullscreen-body");
                $fullscreenButtonFirstChild.removeClass("glyphicon-fullscreen");
                $fullscreenButtonFirstChild.addClass("custom-glyphicon-fullscreen-off"); // XXX: Glyphicons distributed with Bootstrap 3.x lacks fullscreen-off
            } else {
                $("#ReaderDiv").removeClass("fullscreen");
                $("body").removeClass("fullscreen-body");
                $fullscreenButtonFirstChild.removeClass("custom-glyphicon-fullscreen-off");
                $fullscreenButtonFirstChild.addClass("glyphicon-fullscreen");
            }
            this.parentReader.readerLayout.updateSize();
        });
        bookHeaderButtons.appendChild(fullscreenButton);

        bookHeaderButtonsWrapper.appendChild(bookHeaderButtons);
        bookInfoDiv.appendChild(bookHeaderButtonsWrapper);

        var hiddenDiv = document.createElement("div"); // hiddenDetails
        $(hiddenDiv).addClass("collapse collapsible-details");
        // var bookFullInfoDiv = document.createElement("div"); // XXX: unnecessary, but good for a reference (educational)
        // $(bookFullInfoDiv).addClass("book-full-info-container");
        // bookFullInfoDiv.appendChild(editionNoteDiv);
        hiddenDiv.appendChild(this.getBookDetail());
        // hiddenDiv.appendChild(bookFullInfoDiv);

        $(hiddenDiv).on("hidden.bs.collapse shown.bs.collapse", () => {
            this.parentReader.readerLayout.updateSize();
        });

        bookInfoDiv.appendChild(hiddenDiv);

        var hiddenCommentary = document.createElement("div");
        $(hiddenCommentary).addClass("collapse collapsible-commentary");
        hiddenCommentary.appendChild(editionNoteDiv);

        $(hiddenCommentary).on("hidden.bs.collapse shown.bs.collapse", () => {
            this.parentReader.readerLayout.updateSize();
        });

        bookInfoDiv.appendChild(hiddenCommentary);

        return bookInfoDiv;
    }
}

class ButtonFactory {
    private readerLayout: ReaderLayout;
    private deviceType: Device;

    constructor(readerLayout: ReaderLayout, deviceType: Device) {
        this.readerLayout = readerLayout;
        this.deviceType = deviceType;
    }

    public createViewButton(iconName: string, label: string, panelHeader: string, tooltip: string, buttonId: string): HTMLButtonElement {
        var button: HTMLButtonElement = document.createElement("button");
        $(button).addClass(buttonId + "-button");
        var span = document.createElement("span");
        $(span).addClass("glyphicon glyphicon-" + iconName);
        $(button).append(span);

        var spanText = document.createElement("span");
        $(spanText).addClass("button-text");
        $(spanText).append(label);
        $(button).append(spanText);

        // XXX: this can be used to explain what these buttons actually do, in more words
        if (tooltip)
            button.title = tooltip;

        $(button).click(() => {
            if (!panelHeader) // === null
                panelHeader = spanText.innerHTML;

            if (this.deviceType === Device.Desktop) {
                this.readerLayout.createDesktopViewPanel(buttonId, panelHeader);
            } else {
                this.readerLayout.createMobileViewPanel(buttonId, panelHeader);
            }
        });
        return button;
    }

    public createToolButton(
        iconName: string,
        label: string,
        buttonId: string,
        hasToolPanel: boolean = true
    ): HTMLButtonElement
    {
        var button: HTMLButtonElement = document.createElement("button");
        $(button).addClass(buttonId + "-button");

        // NOTE: this one used to be created with a createButton as just an icon
        //       with no text – so adjust margins accordingly (reduce them)
        if (!hasToolPanel) {
            $(button).addClass('with-text');
        }

        if (buttonId === this.readerLayout.searchPanelId && this.readerLayout.getSearchResultPanel() == null) {
            $(button).prop("disabled", true);
        }

        var span = document.createElement("span");
        $(span).addClass("glyphicon glyphicon-" + iconName);
        $(button).append(span);

        var spanText = document.createElement("span");
        $(spanText).addClass("button-text");
        $(spanText).append(label);
        $(button).append(spanText);

        if (hasToolPanel)
        $(button).click(() => {
            if (this.deviceType === Device.Desktop) {
                this.readerLayout.createDesktopToolPanel(buttonId, spanText.innerHTML);
            } else {
                this.readerLayout.createMobileToolPanel(buttonId, spanText.innerHTML);
            }
        });
        return button;
    }

    public createAddBookmarkButton(iconName: string, label: string, buttonId: string): HTMLButtonElement {
        var button: HTMLButtonElement = document.createElement("button");
        $(button).addClass(buttonId + "-button");
        var span = document.createElement("span");
        $(span).addClass("glyphicon glyphicon-" + iconName);
        $(button).append(span);

        var spanText = document.createElement("span");
        $(spanText).addClass("button-text");
        $(spanText).append(label);
        $(button).append(spanText);


        $(button).click(() => {
            const currentPageName = this.readerLayout.getCurrentPage().text;
            this.readerLayout.getNewFavoriteDialog().show(currentPageName);
        });

        return button;
    }

    public createButton(buttonId: string, iconName: string): HTMLButtonElement {
        var button = document.createElement("button");
        $(button).addClass(buttonId + "-button button");

        var span = document.createElement("span");
        $(span).addClass("glyphicon glyphicon-" + iconName);
        $(button).append(span);

        return button;
    }

    public createLink(buttonId: string, iconName: string): HTMLAnchorElement {
        var button = document.createElement("a");
        $(button).addClass(buttonId + "-button");

        var span = document.createElement("span");
        $(span).addClass("glyphicon glyphicon-" + iconName);
        $(button).append(span);

        return button;
    }
}

enum Device {
    Mobile,
    Desktop
}

interface IReaderOptions {
    displayNotes: boolean;
}

export { BookHeader, Device };
